import { AppRootStateType } from 'state/store';

export const adminsSelect = (state: AppRootStateType) => state.admins.admins;

export const adminsLoadingSelect = (state: AppRootStateType) =>
  state.admins.isLoading;

export const adminErrorSelect = (state: AppRootStateType) => state.admins.error;
